import React, {Component} from 'react';
import debounce from 'lodash.debounce';
import './SuperAdminSettingsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import mainAPI from '../../api/MainAPI';
import history from '../../history';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import CreateNewDrugTypePopup from '../../popups/createNewDrugTypePopup/CreateNewDrugTypePopup';
import FilterInput from "../../inputs/filterInput/FilterInput";
import GeneralPopup from "../../popups/generalPopup/GeneralPopup";
import UniversalDropDown from "../../components/universalDropDown/UniversalDropDown";
import Icon from "../../components/icon/Icon";

export default class SuperAdminSettingsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount = async () => {
		let user_groups = await mainAPI.user_group.allWithMetrics();
		let organizations = await mainAPI.organization.all();
		this.setState({user_groups, organizations});
	};

	_showCreateDrugTypePopup = () => {
		window.popupController.show(CreateNewDrugTypePopup, {
			title: 'Create new drug type',
			onComplete: async (newDrug) => {
				return mainAPI.drug_type.create(newDrug);
			}
		});
	};

	_createGroup = () => {
		history.navigate('/group/create');
	};

	onOrganizationChange = (organizationId) => {
	   this.setState({organizationId});
	};

	_renderGroups = () => {
		let display = [];
		display.push(<div
											className="row"
			>
			<Label black>Name</Label>
			<Label black>Overdue Invoice</Label>
			<Label black>Negative Review</Label>
			<Label black>Positive Review</Label>
			<Label black>Supply Units</Label>
			<Label black>Deployed Units</Label>
			<Label black>Inactive for</Label>
		</div>)
		for (let i in this.state.user_groups) {
			if(this.state.organizationId){
				if(this.state.organizationId !== this.state.user_groups[i].organization_id){
					continue;
				}
			}
			let user_group = this.state.user_groups[i];
			display.push(
				<div tabIndex="0"
						 className="row"
						 onClick={() => {
							 history.push('/group/users/' + user_group.id);
						 }}
				>
					<Label black>{user_group.name}</Label>
					<Label red>{user_group.has_overdue_invoice ? 'Overdue Invoice' : ''}</Label>
					<Label red>{(user_group.negative_percent || 0).toFixed(1) + '%'}</Label>
					<Label green>{(user_group.positive_percent || 0).toFixed(1) + '%'}</Label>
					<Label black>{(user_group.supply_units_count || 0)}</Label>
					<Label black>{(user_group.deployed_units_count || 0)}</Label>
					<Label black>{((Date.now() - (new Date(user_group.last_active_on)).getTime()) / 1000 / 60/ 60/ 24).toFixed(1)} Days</Label>
				</div>
			);
		}
		return display;
	};

	_showUserAgenciesPopup = async (user) => {
		const userGroups = await mainAPI.user_group.for_user({user_id:user.id, include_disabled:true});
		window.popupController.show(GeneralPopup, {
			onClose: () => {
				window.popupController.hide(GeneralPopup)
			},
			content: (
				<Card className={'g-agencies-card'}>
					<Label large black>Agencies for {user.first_name} {user.last_name}</Label>
					{userGroups.map((group, index) => (
						<div key={index} className="agency-row">
							<Label  onClick={() => {
								history.push('/group/users/' + group.id);
								window.popupController.hide(GeneralPopup)
							}} black>{group.name}</Label>
							{isValidDate(group.inactive_after_date) &&
							<Label black>
								<Icon className="disabled icon" size="x-small" name={'block'} />
							</Label>}
						</div>
					))}
				</Card>
			)
		});
	};

	_renderUsers = () => {
		if (!this.state.users) return null;
		
		return (
			<>
				<div className="user-row header">
					<Label black>First Name</Label>
					<Label black>Last Name</Label>
					<Label black>Email</Label>
					{/*<Label black>Disabled On</Label>*/}
					<Label black>Last Active</Label>

				</div>
				{this.state.users.map((user, index) => (
					<div 
						key={index} 
						className="user-row"
						onClick={() => this._showUserAgenciesPopup(user)}
						style={{ cursor: 'pointer' }}
					>
						<Label black>{user.first_name}</Label>
						<Label black>{user.last_name}</Label>
						<Label black>{user.primary_email}</Label>
						{/*<Label black>{parseDateOrNull(user.inactive_after)}</Label>*/}
						<Label black>{parseDateOrNull(user.last_active_on)}</Label>
					</div>
				))}
			</>
		);
	};

	_handleFilterChange = debounce(async (value, column) => {
		const filter = this.state.filter || {};
		filter[column] = value;
		this.setState({filter});
		await this.searchUsers(filter);
	}, 600);

	searchUsers = async (filter) => {
		const users = await mainAPI.user.search(filter)
		this.setState({users});
	};

	render() {
		return (
			<Page className="g-super-admin-settings-page">
				<Card className="user-search">
					<Label larger black>
						Users
					</Label> <FilterInput
					onSearchChange={this._handleFilterChange}
					title={'User Search'}
					options={[
						{
							column: 'first_name',
							displayName: 'First Name',
							filterColumns: ['first_name']
						},
						{
							column: 'last_name',
							displayName: 'Last Name',
							filterColumns: ['last_name']
						},
						{
							column: 'primary_email',
							displayName: 'Email',
							filterColumns: ['primary_email']
						}
					]}
				/>
				{this._renderUsers()}
				</Card>
				<Card>
					<UniversalDropDown options={this.state.organizations} placeholder={"Organization Filter"} onChange={this.onOrganizationChange}/>
					<div className="top-row">
						<Label larger black>
							Agencies
						</Label>
						<div className="actions">
							<PrimaryButton className="create-group" onClick={this._createGroup} color="white" bg="blue">
								Create New Agency
							</PrimaryButton>
							<PrimaryButton
								className="create-drug-type"
								onClick={this._showCreateDrugTypePopup}
								color="white"
								bg="blue"
							>
								Create New Drug
							</PrimaryButton>
						</div>
					</div>
					{this._renderGroups()}
				</Card>
			</Page>
		);
	}
}
function parseDateOrNull(dateString) {
	const date = new Date(dateString);
	return isNaN(date.getTime()) ? null : date.toLocaleDateString();
}

function isValidDate(value) {
	if(value === null)return false;
	if(value === undefined)return false;
	const date = new Date(value);
	return !isNaN(date.getTime());
}


// WEBPACK FOOTER //
// ./src/pages/superAdminSettingsPage/SuperAdminSettingsPage.jsx